module.exports = __webpack_public_path__ + "static/training1-e3b64ee40926480e301f848956a95d42.jpeg";